export const FETCH_POSTS = "posts/fetchPostsSuccess";
export const FETCH_CATEGORIES = "posts/fetchCategoriesSuccess";
export const LOADING_SET = "loading/setLoading"